import { render, staticRenderFns } from "./GuidelinePostContent.vue?vue&type=template&id=be6be692&scoped=true&"
import script from "./GuidelinePostContent.vue?vue&type=script&lang=js&"
export * from "./GuidelinePostContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6be692",
  null
  
)

export default component.exports